import type { RouteRecordRaw } from 'vue-router';
import Permission from '@/modules/current-user/permissions/permissions';
import { unrestrictedSupplierAccessGuard } from '@/routes/guards/supplierRestriction';

export const insightsDashboardRoute: RouteRecordRaw = {
  path: 'insights',
  name: 'insights-dashboard',
  component: () => import('./InsightsDashboard.vue'),
  beforeEnter: [unrestrictedSupplierAccessGuard],
  meta: {
    permissions: [Permission.ClientsInsightsView],
  },
};

export const insightsPageRoute: RouteRecordRaw = {
  path: 'insights/:id',
  name: 'insights',
  component: () => import('./InsightsPage.vue'),
  beforeEnter: [unrestrictedSupplierAccessGuard],
  props: true,
};
